export default __webpack_public_path__ + "static/media/relationClient.818e0cc9.svg";